<template>
  <div v-if="profileModalActive">
    <v-dialog
      v-model="profileModalActive"
      lazy
      fullscreen
      scrollable
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>
            {{
              $t('titles.global.updateModel', {
                field: $t('titles.users.profile'),
              })
            }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn dark icon @click="toggleProfileModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <tab-information
            v-if="user"
            ref="tabInformation"
            :user.sync="user"
            :file.sync="file"
            profile-view
          />
          <tab-roles :roles="roles" />
        </v-card-text>
        <v-card-actions>
          <span style="color: red">*</span>
          <span>{{ $t('action.messages.fieldRequired') }}</span>
          <v-spacer />
          <meta-button type="update" :loading="loading" @click="submit()" />
          <meta-button type="cancel" @click="cancel" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabRoles from './TabRoles'
import TabInformation from '@/components/management/users/StepInformation'
import { parseObject, formatDatePicker } from '@/helpers'

export default {
  name: 'ProfileView',
  components: { TabInformation, TabRoles },
  data() {
    return {
      user: null,
      roles: [],
      file: '',
    }
  },
  mounted() {
    this.setObject(this.selected)
    // this.initData()
  },
  computed: {
    ...mapState({
      selected: (state) => state.users.selected,
      loading: (state) => state.users.loading,
      profileModalActive: (state) => state.auth.profileModalActive,
    }),
  },
  watch: {
    profileModalActive(val) {
      if (val) this.initData()
    },
    selected: {
      handler: function (val) {
        if (val && this.profileModalActive) this.setObject(val)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      setUpdate: 'users/update',
      reset: 'users/reset',
      toggleProfileModal: 'auth/toggleProfileModal',
      fetchCountries: 'countries/fetchSelectList',
      fetchProvinces: 'provinces/fetchSelectList',
      fetchTowns: 'towns/fetchSelectList',
      // fetchRoles: 'roles/fetchList',
      // fetchEntities: 'entities/fetchList',
      // fetchTeams: 'teams/fetchList',
      // fetchTournaments: 'tournaments/fetchList',
      // fetchUsers: 'users/fetchList',
      uploadFile: 'files/uploadFile',
    }),
    initData() {
      // this.resetPagitations()
      // this.fetchCountries()
      // this.fetchProvinces()
      // this.fetchTowns()
    },
    submit() {
      this.$refs.tabInformation.validate().then((valid) => {
        if (!valid) return
        let payload = Object.assign({}, this.user)
        if (payload._id) {
          this.setUpdate(payload).then((item) => {
            if (this.file) {
              this.uploadFile({ objectId: item._id, file: this.file })
            }
            this.cancel()
          })
        }
      })
    },
    setObject(user) {
      this.user = parseObject(user)
      this.user.birthdayDate = formatDatePicker(user.birthdayDate)
      this.clearObject()
      if (this.selected.roles) {
        this.roles = this.selected.roles.map((item) => ({
          _id: item.roleId._id,
          name: item.roleId.name,
          objects: item.objects,
          objectId: item.objectId.slice(),
          confirm: item.confirm,
        }))
      }
      // if (this.user.countryId) {
      //   this.fetchProvinces({ countryId: this.user.countryId, limit: 0 })
      // }
      // if (this.user.provinceId) {
      //   this.fetchTowns({ provinceId: this.user.provinceId, limit: 0 })
      // }
    },
    cancel() {
      this.clear()
      this.toggleProfileModal()
    },
    clear() {
      this.reset()
      this.roles = []
      this.user = null
      this.$nextTick(() => {
        if (this.$refs.tabInformation) this.$refs.tabInformation.clear()
      })
    },
    clearObject() {
      delete this.user.roles
      delete this.user.username
      delete this.user.lastAccess
      delete this.user.tokens
      delete this.user.register
      delete this.user.devices
      delete this.user.following
      delete this.user.deleted
      delete this.user.validated
    },
  },
}
</script>
